import { Text } from "@nextui-org/react"

import { Box } from "../../../ui/layout/box"

import './index.css'

export default ({text, isStartup}) => {
    return (
        <>
            <Box 
                className={`dialog-box ${isStartup ? 'start-up' : 'academic'}`}
                css={{
                    backgroundColor: '$brandColor200'
                }}>
                <Box className="arrow" css={{borderBottomColor: "$brandColor200 !important"}}></Box>
                <Text 
                    size="$sm" 
                    className="font-text bold"
                    css={{
                        ta: "left"
                    }}>{text}</Text>
            </Box>
        </>
    )
}